import { Button } from "primereact/button";
import { Driver } from "../../../types";
import { confirmDialog } from "primereact/confirmdialog";
import { useSetDriverData } from "../../../hooks/useSetDataByView/useDriverData.ts";

import { useShowToast } from "../../../contexts/ToastContext.tsx";

export default function DeleteDriver({ rowData }: { rowData: Driver }) {
  const { deleteData } = useSetDriverData();
  const showToast = useShowToast();

  const confirmRemove = () => {
    confirmDialog({
      message: `Czy na pewno chcesz usunąć "${rowData.firstName} ${rowData.lastName}"?`,
      header: "Potwierdź usunięcie",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Usuwać",
      rejectLabel: "Anulować",
      accept: () => {
        void (async () => {
          try {
            await deleteData(rowData.id);
            showToast({
              severity: "success",
              summary: "Usunięto kierowcę",
              detail: `Kierowca ${rowData.firstName} ${rowData.lastName} został usunięty.`,
            });
          } catch (_error) {
            showToast({
              severity: "error",
              summary: "Błąd",
              detail: "Nie udało się usunąć kierowcy.",
            });
          }
        })();
      },
      acceptClassName: "p-button-danger",
      className: "custom-confirm-dialog",
    });
  };

  return (
    <Button
      size="small"
      icon="pi pi-trash"
      text
      severity="danger"
      onClick={(e) => {
        e.stopPropagation();
        confirmRemove();
      }}
    />
  );
}
